import React from 'react';
import PropTypes from 'prop-types';
import { getQueryParams } from '../../utils/common';
import ElectionWidgetWrapper from './ElectionWidgetWrapper';
import ArticleShowBriefWidgetWrapper from './ArticleshowBriefWrapper';

/**
 * HOC component acts as a generic wrapper for widget component and applies styling.
 * Can also be used to map different wrapper as per widget by creating specific wrapper component.
 * @param {*} param0 : Widget configurations.
 */
const WithWrapper = ({
  widgetName,
  Widget,
  url,
  defaultprops,
  classes,
  styles,
  isWapView,
  tabs,
}) => () => (
  <div>
    {(() => {
      switch (widgetName.toUpperCase()) {
        case 'VIDEOPLAYER':
          return (
            <VideoPlayerWidgetWrapper
              Widget={Widget}
              defaultprops={defaultprops}
              classes={classes}
              styles={styles}
              url={url}
            />
          );
        case 'ARTICLESHOWBRIEFS':
          return (
            <ArticleShowBriefWidgetWrapper
              Widget={Widget}
              defaultprops={defaultprops}
              classes={classes}
              styles={styles}
              url={url}
              isWapView={isWapView}
            />
          );
        // TODO: Election Widget
        case 'ELECTIONWDT':
          return (
            <ElectionWidgetWrapper
              Widget={Widget}
              defaultprops={defaultprops}
              classes={classes}
              styles={styles}
              url={url}
              tabs={tabs}
            />
          );
        default:
          return null;
      }
    })()}
  </div>
);

WithWrapper.propTypes = {
  widgetName: PropTypes.string.isRequired,
  Widget: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  defaultprops: PropTypes.shape({}).isRequired,
  classes: PropTypes.string,
  styles: PropTypes.string,
};

WithWrapper.defaultProps = {
  classes: '',
  styles: '',
};

/**
 * Wrapper around video player widget for extra enhancement like styling, adding elements etc.
 * @param {*} props : React props
 */
const VideoPlayerWidgetWrapper = props => {
  const { Widget, classes, styles, defaultprops, url } = props;
  const slikeVideoId = getQueryParams('id', { href: url });
  const msid = getQueryParams('msid', { href: url });
  const secid = getQueryParams('secid', { href: url });
  const requrl = getQueryParams('requrl', { href: url });
  return (
    <div style={styles} className={classes}>
      <Widget
        {...defaultprops}
        {...props}
        slikeVideoId={slikeVideoId}
        url={url}
        msid={msid}
        secid={secid}
        requrl={requrl}
      />
    </div>
  );
};

VideoPlayerWidgetWrapper.propTypes = {
  Widget: PropTypes.node.isRequired,
  defaultprops: PropTypes.shape({}).isRequired,
  url: PropTypes.string.isRequired,
  classes: PropTypes.string,
  styles: PropTypes.string,
};

VideoPlayerWidgetWrapper.defaultProps = {
  classes: '',
  styles: '',
};

export default WithWrapper;
